module.exports = __webpack_public_path__ + "static/media/img11.d12b80f1.png";